import request from '@/utils/request'

export function getDocsGovernanceOverview () {
  return request({
    url: '/addon/docsGovernance/overview',
    method: 'get'
  })
}
